import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { EventNames } from '@iheartjane/tracking';
import isEqual from 'lodash-es/isEqual';
import { useEffect, useRef } from 'react';

import { crmTrack } from './crmTrack';
import type { TrackedEvent } from './event.types';
import { track } from './track';

export const useTrack: (event: TrackedEvent | null) => void = (event) => {
  const lastEvent = useRef<TrackedEvent | null>(null);
  const crmTrackingEnabled = useFlag(FLAGS.bbCrmTracking);

  useEffect(() => {
    if (event && !isEqual(event, lastEvent.current)) {
      // regular tracking does not track viewed special
      if (event.event !== EventNames.ViewedSpecial) {
        track(event);
      }

      crmTrack(event, crmTrackingEnabled);
      lastEvent.current = event;
    }
  });
};

export const Track = ({ event }: { event: TrackedEvent | null }) => {
  useTrack(event);
  return null;
};
